import React from 'react';
import "../styling/header.css"

const HeaderComponent = () => {

return (

<nav className="site-header sticky-top py-1 ">
    <div className="container d-flex  flex-md-row ">
        <a className="py-2 d-md-inline-block aWrap" rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/in/fatinnabila/">
           LinkedIn
        </a>

        <a className="py-2 d-md-inline-block aWrap" rel="noopener noreferrer" target="_blank" href="https://github.com/fatinabila">
          Github
        </a>
    </div>
</nav>
        
)

}

export default HeaderComponent;